export default "__VITE_ASSET__BS2YnBoE__"